import { YOUTUBE_EMBED_BASE_URL, YOUTUBE_EMBED_DEFAULT_QUERY, YOUTUBE_VIDEO_ID_PATTERN } from '../back-office-conf';

export const toYoutubeEmbedUrl = (url: string): string => {
  const videoId = url?.match(YOUTUBE_VIDEO_ID_PATTERN)?.[1];
  return videoId ? `${YOUTUBE_EMBED_BASE_URL}${videoId}${YOUTUBE_EMBED_DEFAULT_QUERY}` : url;
}

export const formatYoutubeUrlToEmbed = (url: string) => {
  if (!url) {
    return '';
  }
  let result = toYoutubeEmbedUrl(url);
  if (!result.includes(YOUTUBE_EMBED_DEFAULT_QUERY)) {
    result += YOUTUBE_EMBED_DEFAULT_QUERY;
  }
  return result;
}
